var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 26,
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53652 25.3242C1.44189 15.0391 0.125 13.9835 0.125 10.2036C0.125 5.02593 4.32231 0.828613 9.5 0.828613C14.6777 0.828613 18.875 5.02593 18.875 10.2036C18.875 13.9835 17.5581 15.0391 10.4635 25.3242C9.9979 25.9968 9.00205 25.9967 8.53652 25.3242ZM9.5 14.1099C11.6574 14.1099 13.4062 12.361 13.4062 10.2036C13.4062 8.04624 11.6574 6.29736 9.5 6.29736C7.34263 6.29736 5.59375 8.04624 5.59375 10.2036C5.59375 12.361 7.34263 14.1099 9.5 14.1099Z",
    fill: "#040707"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/MapIcon.b5336e2d3cddfbec34a93946451bf346.svg";
export { ForwardRef as ReactComponent };